var map = {
	"./en/contact-form.json": 88836,
	"./en/departments.json": 88639,
	"./en/donation-box.json": 84710,
	"./en/event.json": 58842,
	"./en/footer.json": 49070,
	"./en/global.json": 3442,
	"./en/home.json": 51084,
	"./en/legacy-simulator.json": 44779,
	"./en/news.json": 27693,
	"./en/research-group-or-platform.json": 31888,
	"./en/search.json": 7386,
	"./fr/contact-form.json": 69276,
	"./fr/departments.json": 69286,
	"./fr/donation-box.json": 4309,
	"./fr/event.json": 11585,
	"./fr/footer.json": 19035,
	"./fr/global.json": 39330,
	"./fr/home.json": 46256,
	"./fr/legacy-simulator.json": 86936,
	"./fr/news.json": 80745,
	"./fr/research-group-or-platform.json": 13579,
	"./fr/search.json": 73780,
	"./nl/contact-form.json": 43817,
	"./nl/departments.json": 12137,
	"./nl/donation-box.json": 7273,
	"./nl/event.json": 31995,
	"./nl/footer.json": 70891,
	"./nl/global.json": 98803,
	"./nl/home.json": 79079,
	"./nl/legacy-simulator.json": 16006,
	"./nl/news.json": 52703,
	"./nl/research-group-or-platform.json": 75483,
	"./nl/search.json": 14858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74886;